import axios from "axios";
import { apiURI, authErrorRedirect, processImages } from "../../../common";

export async function handleProcurementSaveEditedItem(
  setErrors,
  props,
  productImagesNew,
  setPatienceTimer,
  setIsCompressing,
  dataRest,
  values,
  existingProductImages,
  history,
  setValues,
  setIsSubmitting,
  handleClose,
  initialValues,
) {
  setErrors({});

  const newArr = props.itemList.filter(
    (obj) => obj.sampleItemID !== props.data.sampleItemID,
  );

  // processImages now reliably awaits FileReader completion (getBase64 race condition fixed)
  let productImagesToUpload = await processImages(
    productImagesNew,
    setPatienceTimer,
    setIsCompressing,
  );

  let newData = {
    ...props.detailsData,
    items: [
      {
        ...dataRest,
        ...values,
        productImage: [...existingProductImages, ...productImagesToUpload],
        dateModified: Date.now(),
      },
      ...newArr,
    ],
  };

  await axios
    .post(`${apiURI}/form/procUpdateItem`, newData)
    .then(() => window.location.reload(true))
    .catch((response) => {
      console.log("error in axios form call react");
      setErrors({});
      setErrors(response.response.data);
      authErrorRedirect(response.response.data, history);
    });

  setValues({ ...initialValues });
  setIsSubmitting(false);
  handleClose();
}
